import React, { useEffect, useRef } from 'react';
import { FaBrain, FaMobileAlt, FaChartLine, FaShieldAlt } from 'react-icons/fa';
import './Features.css';

const Features = () => {
  const featureCardsRef = useRef([]);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1 }
    );
    
    featureCardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });
    
    return () => {
      featureCardsRef.current.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);
  
  const features = [
    {
      icon: <FaBrain />,
      title: 'AI-Powered Diagnosis',
      description: 'Accurate wound detection and analysis using advanced machine learning algorithms'
    },
    {
      icon: <FaMobileAlt />,
      title: 'Remote Monitoring',
      description: 'Track healing progress remotely with secure data sharing between patients and providers'
    },
    {
      icon: <FaChartLine />,
      title: 'Medical Insights',
      description: 'Data-driven healing predictions and personalized treatment recommendations'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Secure & Scalable',
      description: 'HIPAA-compliant infrastructure with enterprise-grade security and reliability'
    }
  ];
  
  return (
    <section id="features" className="features">
      <div className="container">
        <h2>Transforming Healthcare with AI</h2>
        <div className="feature-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card"
              ref={(el) => (featureCardsRef.current[index] = el)}
            >
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
